import { createApp } from 'vue';
import ProductPurchase from '../components/ProductPurchase.vue';

export const initProductPurchase = () => {
	const roots = document.querySelectorAll('[data-vue-product-purchase]');

	roots.forEach((root) => {
		createApp(ProductPurchase, {
			initialVariantId: root.dataset.initialVariantId || ''
		}).mount(root);
	});
};
